import React, { useState, useMemo } from 'react';
import { Search, PlusCircle } from 'lucide-react';

const AddProjectFromTemplateSection = ({
  templates,
  templatesLoading,
  onAddProject, // Renamed from handleAddProjectFromTemplate for clarity
  addingProjectFromTemplateId,
  tooltipProps,
}) => {
  const [templateSearchQuery, setTemplateSearchQuery] = useState("");

  // Filtrowanie szablonów
  const filteredTemplates = useMemo(() => {
    if (!templateSearchQuery) {
      return templates;
    }
    const query = templateSearchQuery.toLowerCase().trim();
    return templates.filter(templateFile =>
      (templateFile.fileName?.toLowerCase() || '').includes(query) ||
      (templateFile.docTitle?.toLowerCase() || '').includes(query)
    );
  }, [templates, templateSearchQuery]);

  return (
    <div className="client-panel-add-template-section">
      <h3 className="client-panel-section-title">Dodaj nowy projekt z szablonu</h3>
      <div className="template-search-container">
        <Search size={18} className="search-icon" />
        <input
          type="text"
          placeholder="Wyszukaj szablon po nazwie..."
          value={templateSearchQuery}
          onChange={(e) => setTemplateSearchQuery(e.target.value)}
          className="template-search-input"
        />
      </div>

      {templatesLoading ? (
        <p>Ładowanie szablonów...</p>
      ) : templates.length === 0 ? (
        <p>Brak dostępnych szablonów.</p>
      ) : filteredTemplates.length === 0 ? (
        <p>Nie znaleziono szablonów pasujących do zapytania.</p>
      ) : (
        <ul className="template-list">
          {filteredTemplates.map(templateFile => (
            <li key={templateFile.id} className="template-list-item">
              <span>
                {templateFile.docTitle || templateFile.fileName}
                {templateFile.collectionName && <span style={{ color: '#888', marginLeft: '8px', fontSize: '0.9em' }}>({templateFile.collectionName})</span>}
              </span>
              <button
                className="client-btn-icon client-btn-icon-add"
                onClick={() => onAddProject(templateFile.id)}
                disabled={addingProjectFromTemplateId === templateFile.id}
                {...tooltipProps("Dodaj ten projekt z szablonu do zamówienia")}
              >
                {addingProjectFromTemplateId === templateFile.id ? (
                  <div className="popup-spinner popup-spinner-button"></div>
                ) : (
                  <PlusCircle size={16} />
                )}
              </button>
            </li>
          ))}
        </ul>
      )}
    </div>
  );
};

export default AddProjectFromTemplateSection;
